import { filters } from "./filters";
import { navigation } from "./navigation";
import { table } from "./table";
import { modals } from "./modals";
import { notifications } from "./notifications";
import { page } from "./page";
import { floatingActions } from "./floating-actions";
import { fiscalTest } from "./fiscal-test";
import { newPageNotificationModal } from "./new-page-notification-modal";

export const productList = {
	filters,
	navigation,
	table,
	modals,
	notifications,
	page,
	floatingActions,
	fiscalTest,
	newPageNotificationModal,
};
